// extracted by mini-css-extract-plugin
export default {"instrOuterContainer":"RecipeInstructions_instrOuterContainer__GhKAL","instructionsList":"RecipeInstructions_instructionsList__x9a7c"};